
import { chatbox } from '../protobuf/message';

export function encodeMessage(data) {
  return chatbox.Message.encode(data).finish();
}

export function decodeMessage(buffer) {
  return chatbox.Message.decode(buffer);
}
